import { useEffect, useState } from 'react';
import { Fade } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { FiX } from 'react-icons/fi';
import {
  InputText,
  PrimaryButton,
  SecondaryButton,
} from '../../../../shared/ui/Inputs';
import { Modal } from '../../../../shared/ui/Modal';
import { PrimaryTitleGray } from '../../../../app/theme/tokens/colors';
import { CategoryTag, SkuTag, TagsRow } from './catalogStyles';

export const ProductModal = ({ product, open, onClose, onExited, onAdd }) => {
  const isSmallScreen = useMediaQuery({ query: '(max-width: 680px)' });
  const [quantity, setQuantity] = useState(1);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    setQuantity(1);
    setImageIndex(0);
  }, [product]);

  if (!product) return null;

  const detailSections = [
    { title: 'Descrição', text: product.description },
    {
      title: 'Descrição complementar',
      text:
        product.complementaryDescription === product.description
          ? ''
          : product.complementaryDescription,
    },
    { title: 'Informações técnicas', text: product.technicalInformation },
  ].filter((section) => section.text);

  return (
    <Modal open={open} handleClose={onClose} width="1100px">
      <Fade in={open} timeout={{ enter: 220, exit: 180 }} onExited={onExited}>
        <div style={{ minHeight: isSmallScreen ? 'auto' : '540px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '20px',
              alignItems: 'start',
            }}
          >
            <div>
              <TagsRow>
                <CategoryTag>{product.category}</CategoryTag>
                <SkuTag>{product.sku}</SkuTag>
              </TagsRow>
              <span
                style={{
                  display: 'block',
                  color: '#777',
                  fontSize: '13px',
                  marginTop: '9px',
                }}
              >
                {product.subcategory}
              </span>
              <h2
                style={{
                  textAlign: 'left',
                  margin: '10px 0 3px',
                  color: PrimaryTitleGray,
                }}
              >
                {product.name}
              </h2>
            </div>
            <button
              aria-label="Fechar produto"
              onClick={onClose}
              style={{
                border: 0,
                background: 'transparent',
                cursor: 'pointer',
                fontSize: '24px',
                lineHeight: 1,
              }}
            >
              <FiX />
            </button>
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isSmallScreen
                ? '1fr'
                : 'minmax(360px, 1fr) minmax(390px, 1fr)',
              gap: '34px',
              marginTop: '24px',
            }}
          >
            <div>
              <div
                style={{
                  height: isSmallScreen ? '280px' : '445px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '10px',
                  background: '#f5f6f4',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={product.images[imageIndex]}
                  alt={product.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    padding: '18px',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
              {product.images.length > 1 && (
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    marginTop: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                  {product.images.map((src, index) => (
                    <button
                      key={src}
                      onClick={() => setImageIndex(index)}
                      style={{
                        padding: 0,
                        border:
                          index === imageIndex
                            ? '2px solid #318300'
                            : '1px solid #ddd',
                        borderRadius: '6px',
                        background: '#fff',
                        cursor: 'pointer',
                      }}
                    >
                      <img
                        src={src}
                        alt=""
                        style={{
                          width: '58px',
                          height: '46px',
                          objectFit: 'contain',
                          display: 'block',
                        }}
                      />
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div
              style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}
            >
              <div
                style={{
                  color: '#555',
                  lineHeight: 1.55,
                  maxHeight: isSmallScreen ? 'none' : '320px',
                  overflowY: 'auto',
                  paddingRight: '8px',
                }}
              >
                {detailSections.length === 0 ? (
                  <p style={{ margin: 0 }}>
                    Descrição não disponível para este produto.
                  </p>
                ) : (
                  detailSections.map((section) => (
                    <section
                      key={section.title}
                      style={{
                        marginBottom: '12px',
                        border: '1px solid #e0e5dd',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        background: '#fff',
                      }}
                    >
                      <h4
                        style={{
                          color: '#376f1c',
                          fontSize: '13px',
                          margin: 0,
                          padding: '9px 12px',
                          borderBottom: '1px solid #e0e5dd',
                          background: '#f3f8f0',
                        }}
                      >
                        {section.title}
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          padding: '11px 12px',
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {section.text}
                      </p>
                    </section>
                  ))
                )}
              </div>
              <div style={{ marginTop: 'auto', paddingTop: '22px' }}>
                <label
                  style={{
                    display: 'block',
                    color: '#555',
                    fontSize: '13px',
                    fontWeight: 600,
                    marginBottom: '5px',
                  }}
                >
                  Quantidade
                </label>
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                    marginBottom: '20px',
                  }}
                >
                  <SecondaryButton
                    aria-label="Diminuir quantidade"
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  >
                    −
                  </SecondaryButton>
                  <InputText
                    aria-label="Quantidade"
                    type="number"
                    min="1"
                    value={quantity}
                    onChange={(event) =>
                      setQuantity(Math.max(1, Number(event.target.value) || 1))
                    }
                    style={{
                      width: '72px',
                      textAlign: 'center',
                      textIndent: 0,
                    }}
                  />
                  <SecondaryButton
                    aria-label="Aumentar quantidade"
                    onClick={() => setQuantity(quantity + 1)}
                  >
                    +
                  </SecondaryButton>
                </div>
                <PrimaryButton
                  onClick={() => {
                    onAdd(product, quantity);
                    onClose();
                  }}
                  style={{ width: '100%', height: '42px' }}
                >
                  Adicionar ao carrinho
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
